/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

export const sanitizeRedirectURL = (rawUrl: string, origin: string): string => {
	try {
		const url = new URL(rawUrl);
		if (url.origin === origin) {
			return url.toString();
		}
	} catch {
		return "";
	}
	return "";
};
